import { GallerySection } from "@/types";
import { ImageGallery } from "./ImageGallery";

export const GallerySectionComponent = ({ content }: { content: GallerySection }) => {
	return (
		<section className="section-wrapper --no-padding-top">
			<div className="max-wrapper-content gallery-wrapper --single">
				<ImageGallery images={content.image} />
			</div>
		</section>
	);
};
